/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'square_tool': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><clipPath id="svgicon_square_tool_a"><path pid="0" d="M0 0h24v24H0z"/></clipPath></defs><g data-name="Rectangle 20" _fill="none" _stroke="#1d1d1d" stroke-width="2.5" clip-path="url(#svgicon_square_tool_a)"><path pid="1" _stroke="none" d="M3 3h18v18H3z"/><path pid="2" d="M4.25 4.25h15.5v15.5H4.25z"/></g>'
  }
})
